import {dndPromotion, getAwardSrcById} from "../../setup/js/_promotion";
import fishControl from "./_fishControl";

$(document).on("vltk_cachep_promotion rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    // if (window.innerHeight > window.innerWidth) {
    //     $('.front').show();
    //     $('.section__background').hide();
    //     $('.section__content').hide();
    //     $(".vltk_cachep_promotion").css("height", "var(--sr-device-height)");
    // }
    // $(window).on('orientationchange', function (e) {
    //     if (window.orientation == 0) {
    //         $('.front').show();
    //         $('.section__background').hide();
    //         $('.section__content').hide();
    //     } else { //90(right);
    //         $('.front').hide();
    //         $('.section__background').show();
    //         $('.section__content').show();
    //     }
    // });
    // let currentPos = currentPosition - 1;
    
    // Control fish position
    fishControl.init();
    // $('.effect .effect__item:eq(' + currentPos + ')').addClass("active");   


    if ($(".promotion_action").length > 0) {
        dndPromotion({
            url: domain,
            debug: true,
            wait: 0,
            directory: "vltkmm/landing/2024-vuot-vu-mon/prod/vltk_cachep/popup/images",
            items: {
                A: "1",
                B: "2",
                C: "3",
                D: "4",
                E: "5",
                F: "6",
                G: "7",
                H: "8",
                I: "9",
                J: "10",
                K: "11",
                L: "12",
                M: "13",
                N: "14",
                O: "15",
                P: "16",
                Q: "17",
                R: "18",
                S: "19",
                T: "20",
                U: "21",
                V: "22",
                W: "23",
                X: "24",
                length: 24,
                type: "png",
            },
            names: [
                "Darkly Divided Crate x25",
                "Darkly Divided Crate x10",
                "Darkly Divided Crate x5",
                "Darkly Divided Crate x10",
                "Darkly Divided Crate x15",
                "Darkly Divided Crate x10",
                "Bloody Vow Crate x25",
                "Bloody Vow Crate x10",
                "Bloody Vow Crate x5",
                "Bloody Vow Crate x10",
                "Bloody Vow Crate x15",
                "Bloody Vow Crate x10",
                "Beachcomber Crate x25",
                "Beachcomber Crate x10",
                "Beachcomber Crate x15",
                "Beachcomber Crate x10",
                "Beachcomber Crate x5",
                "Beachcomber Crate x10",
                "Anime Super Crate x25",
                "Anime Super Crate x10",
                "Anime Super Crate x15",
                "Anime Super Crate x10",
                "Anime Super Crate x5",
                "Anime Super Crate x10",
            ],
            callback: function () {
            },
            animBefore: function () {
                $("#action").addClass("off");
            },
            animResult: (listPrize, responseData, totalPoint) => {
                if (typeof LuckyDrawExchangeModule !== 'undefined') {
                    LuckyDrawExchangeModule.fetchViewData();
                }

                // console.log(listPrize, responseData);

                $("#popup_effect").removeClass("active");
                $(".fish_effect").removeClass("animating");
                $("#popup_xucxac").addClass("active");
                $(".promotion_dice").removeClass("dicing");

                var fishJumpInterval;
                            
                $(".go").one("click", function() {
                    $("#popup_xucxac").removeClass("active");
                    $(".skip").addClass("active");
                    // const fishNextPos = listPrize[listPrize.length - 1].newPosition;
                    // console.log(fishNextPos);
                    var fishJumpSequenceId = 0;
                    fishJumpInterval = setInterval(() => {
                        const nextPos = listPrize[fishJumpSequenceId].newPosition;
                        fishControl.fishJumpTo(nextPos);
                        fishJumpSequenceId++;

                        if (fishJumpSequenceId >= listPrize.length) {
                            clearInterval(fishJumpInterval);
                            setTimeout(() => {
                                // fishControl.setFishJumpingType('jump');
                                // fishControl.setFishPosition(fishControl.getSlotOffset(nextPos));
                                $(".promotion_action").removeClass("off");
                            }, 1000);
                                

                            // console.log(totalPoint);
                            if (typeof totalPoint != "undefined") {
                                setTimeout(() => {
                                    $("#popup_reward").addClass("active");
                                    $(".skip").removeClass("active");
                                    $("#rewardPoints").html(totalPoint);
                                }, 2000);
                            }
                        }
                    }, 1200);


                });

                $(".btn_skip").one("click", function() {
                    clearInterval(fishJumpInterval);
                    fishControl.fishJumpTo(listPrize[listPrize.length - 1].newPosition);
                    $(".promotion_action").removeClass("off");
                    $(".skip").removeClass("active");
                    $("#popup_xucxac").removeClass("active");
                    $("#rewardPoints").html(totalPoint);
                    $("#popup_reward").addClass("active");
                    // fishControl.setFishJumpingType('jump');
                    // fishControl.setFishPosition(fishControl.getSlotOffset(listPrize[listPrize.length - 1].newPosition));
                });

            },
            animWait: function () {
                $("#popup_effect").addClass("active");
                $(".fish_effect").addClass("animating");


                $(".promotion_action").addClass("off");
                // $("#effect").removeClass("animating");
                $(".promotion_dice").addClass("dicing");
            }
        });

        window['getAwardSrcById'] = getAwardSrcById;
    }



    window.fishControl = fishControl;

    
});
